import { render, staticRenderFns } from "./PriceAgreements.vue?vue&type=template&id=75f5d238&"
import script from "./PriceAgreements.vue?vue&type=script&lang=js&"
export * from "./PriceAgreements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports